"use client";
import { useState } from "react";
import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Badge from "react-bootstrap/Badge";
import { Link as ReactRouterLink } from "react-router-dom";
import "../styles/result-card-grid.css";
import { GridCardTitle } from "./GridCardTitle";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import Tooltip from "react-bootstrap/Tooltip";
import { CardEducationInfo } from "./CardEducationInfo";
import { CardAgeInfo } from "./CardAgeInfo";
import { CardCompanyInfo } from "./CardCompanyInfo";
import { CardLocationInfo } from "./CardLocationInfo";
import { formatMarketCap, toCurrency } from "../utils/searchUtils";
import { CardSkillsInfo } from "./CardSkillsInfo";

const MarketCapInfo = ({ marketCap }) => {
  return (
    <div className="info-item d-flex align-items-center justify-content-between mb-2">
      <div className="d-flex align-items-center flex-grow-1">
        <i className="fas fa-chart-line mr-2" style={{ fontSize: "12px" }} />
        <span className="info-text" style={{ fontSize: "0.85rem" }}>
          Market Cap: {marketCap ? formatMarketCap(marketCap) : "N/A"}
        </span>
      </div>
    </div>
  );
};
const RemunerationInfo = ({ remuneration }) => {
  return (
    <div className="info-item d-flex align-items-center justify-content-between mb-2">
      <div className="d-flex align-items-center flex-grow-1">
        <i className="fas fa-dollar-sign mr-2" style={{ fontSize: "12px" }} />
        <span className="info-text" style={{ fontSize: "0.85rem" }}>
          Remuneration: {remuneration ? toCurrency(remuneration) : "N/A"}
        </span>
      </div>
    </div>
  );
};

export const GridCardInfo = ({ result, allMemberships, hideCompanyInfo }) => {
  // Get primary membership (current role or most recent)
  const currentMemberships = allMemberships?.filter((m) => !m.end_date) || [];
  const primaryMembership = currentMemberships[0] || allMemberships?.[0];

  return (
    <>
      {/* Info Section */}
      <div className="flex-grow-1">
        <div className="info-grid">
          {!hideCompanyInfo && (
            <CardCompanyInfo
              id={result.id}
              name={result.name}
              allMemberships={allMemberships}
            />
          )}
          <MarketCapInfo marketCap={primaryMembership?.market_capital} />
          <RemunerationInfo remuneration={primaryMembership?.remuneration} />
          <CardSkillsInfo skills={result.director_skill_and_experiences} />

          {/* Location */}
          <CardLocationInfo location={result.short_address} />

          {/* Age */}
          <CardAgeInfo ageResult={result} />
          {/* Education */}
          <CardEducationInfo educations={result?.educations} />
        </div>
      </div>
    </>
  );
};
